export type ThemeType = (typeof AvailableThemes)[number];
export const AvailableThemes = ['light', 'dark', 'ims', 'auto'] as const;
